<template>
  <div v-show="isLoaded" class="mBanner_container" v-observe-visibility="startAnimate">
    <img class="mBanner_img" :src="banner" alt="Banner MPT">
    <img class="mBanner_logo" :class="{animate: animate}" :src="logo" alt="Logo MPT">
    <h1 class="mBanner_title" :class="{animate: animate}">Circuito <br>Monterrey</h1>
    <h2 class="mBanner_subtitle" :class="{animate: animate}">Monterrey Padel Tour</h2>
    <h3 class="mBanner_subtitle_two" :class="{animate: animate}"><u>El primer circuito amateur rankiable</u></h3>
    <h3 class="mBanner_subtitle_thee" :class="{onlySafari: isSafari, animate: animate}">Monterrey Padel Tour es una organización apasionada por el desarrollo del <br>
        padel en Nuevo León . Garantizamos el desarrollo de competiciones <br>
        organizadas y estructuradas, que tengan como objetivo impulsar el <br>
        progreso competitivo de todos los jugadores y jugadoras
    </h3>
  </div>
</template>

<script>
import banner from "@/assets/home/banner_two.jpeg";
import logo from "@/assets/logo_MPT.png";
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
export default {
    name: "Banner",
    data() {
        return {
            animate: false,
            isSafari: false,
            banner,
            logo,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true;
            }
        },
    },
    mounted() {},
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Banner.scss";
</style>